export const SUBSCRIPTION_SUMMARY_CONFIG = {
  subscriptionRevenueMrr: {
    label: "Subscription Revenue MRR",
  },
  activeSubscribers: {
    label: "Active Subscribers",
  },
  arpuMonthly: {
    label: "ARPU Monthly",
  },
  churnRate: {
    label: "Churn Rate",
    secondaryValue: "%",
  },
  newSubscriptions: {
    label: "New Subscriptions",
  },
  lifetimeValueLtv: {
    label: "Lifetime Value LTV",
  },
};

export function mapSubscriptionSummaryToKpis(subscriptionSummary = {}) {
  return Object.entries(subscriptionSummary).map(([key, metric]) => {
    const config = SUBSCRIPTION_SUMMARY_CONFIG[key] || {};

    return {
      label: config.label || key,
      value: metric?.value ?? 0,
      status: metric?.trend,
      changePercentage:
        metric?.growthPercentage ?? metric?.changePercentage ?? 0,
      history: metric?.history,
      secondaryValue:
        config.secondaryValue ||
        (metric?.unit === "percentage" ? "%" : metric?.secondaryValue),
      currency: metric?.currency,
    };
  });
}
